<template>
  <div class="grid grow place-items-center overflow-y-auto p-4 sm:py-12">
    <div class="flex w-full min-w-0 max-w-xl flex-col gap-8">
      <slot></slot>
    </div>
  </div>
</template>
